import React, { FC } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { Select, SelectPropertiesInterface } from '@affstore-ds/uikit'

import { InputLoader } from '../../shared/components/InputLoader'
import { commonTranslationKeys } from '../../shared/translations/common.translationKeys'
import { selectTranslationKeys } from '../../shared/translations/select.translationKeys'
import { renderAdvertiserModelItem } from './components/OffersModelsByAdvertiserSelectItem'
import { OffersModelsByAdvertiserSelectTranslationKeys } from './translations/OffersModelsByAdvertiserSelect.translationKeys'

import { useOffersModelsByAdvertiserId } from '../../entities/offer/model/useOffersModelsByAdvertiserId'

export const OffersModelsByAdvertiserSelect: FC<Omit<SelectPropertiesInterface, 'data'> & { advertiserId: number }> = ({
  label,
  advertiserId,
  disabled,
  ...rest
}) => {
  const { i18n } = useI18n()

  const { advertisersModels, isFetching } = useOffersModelsByAdvertiserId(advertiserId)

  return (
    <Select
      data-testid="advertiser-model-select"
      middlewares={{ flip: false, shift: false }}
      label={label || i18n.t(OffersModelsByAdvertiserSelectTranslationKeys.settingsAffiliateModel)}
      bottomSheetTitle={label || i18n.t(OffersModelsByAdvertiserSelectTranslationKeys.settingsAffiliateModel)}
      clearable={false}
      data={advertisersModels}
      disabled={disabled || isFetching}
      maxDropdownHeight="calc(100vh / 2.5)"
      nothingFoundMessage={i18n.t(commonTranslationKeys.commonNoData)}
      placeholder={i18n.t(selectTranslationKeys.selectPlaceholder)}
      position="bottom"
      renderOption={renderAdvertiserModelItem}
      rightSection={isFetching && <InputLoader />}
      variant="responsive"
      withScrollArea={true}
      {...rest}
    />
  )
}
